import { Pagination, usePaginationStore } from '@/store/PaginationStore';

const paginationStore = usePaginationStore()

/**
 * Use this function to initialise the pagination.
 * The list contain an id of the pageable list: if it's different it means that the User want to visit a different list.
 *
 * When data are fetched, please use getPage(), getOrder() and getPerPage().
 *
 * @param list
 * @param page
 * @param perPage
 * @param order
 */
export function buildPagination(list, page, perPage, order) {
    //console.log('buildPagination', list, page, perPage, order);

    if (typeof page === 'undefined') {
        page = 0
    }
    if (typeof perPage === 'undefined') {
        page = 10
    }
    if (typeof order === 'undefined') {
        order = []
    }

    const paginationData = getPaginationData(list)

    if (typeof paginationData === 'undefined') {
        paginationStore.pagination.push(new Pagination(list, page, perPage, order));
    }
}

export function resetPagination(list, page, perPage, order) {
    console.log('resetPagination', list, page, perPage, order);
    setPage(list, page)
    setPerPage(list, perPage)
    setOrder(list, order)

    //console.log('order:', getOrder(list))
}

function getPaginationData(list) {
    return paginationStore.pagination.find(item => {
        if (typeof item.list !== 'undefined') {
            if (item.list === list) {
                return item
            }
        }
    });
}


export function getPage(list) {
    let data = getPaginationData(list)

    if (typeof data === 'undefined') {
        //console.error('getPage', list)
        return 0
    } else {
        return data.page
    }
}

export function setPage(list, page) {
    paginationStore.pagination.find((item, index) => {
        if (typeof item.list !== 'undefined') {
            if (item.list === list) {
                paginationStore.pagination[index].page = page
            }
        }
    });
    //console.log('setPage', list, page)
}

export function getFilters(list) {
    let data = getPaginationData(list)

    if (typeof data === 'undefined') {
        return undefined
    } else {
        return data.filter
    }
}

export function setFilters(list, filter) {
    paginationStore.pagination.find((item, index) => {
        if (typeof item.list !== 'undefined') {
            if (item.list === list) {
                paginationStore.pagination[index].filter = filter
            }
        }
    });
}

export function getOrder(list) {
    //console.log('getOrder', list);

    let data = getPaginationData(list)

    //console.log('getOrder:data', data);

    if (typeof data === 'undefined' || typeof data.order === 'undefined' || data.order === null) {
        //console.error('getOrder', list)
        return []
    } else {
        if (typeof data.order !== 'undefined') {
            //console.log('getOrder data: ', data)
            return data.order
        } else {
            return []
        }

    }
}

export function getOrderForHttp(list) {
    let data = getPaginationData(list)

    console.log('getOrderForHttp', list, data)

    if (typeof data === 'undefined') {
        //console.error('getOrderForHttp', list)
        return ''
    } else {
        if (typeof data.order !== 'undefined') {
            const order = data.order.map((item) => {
                return item.field + ' ' + (item.order === 1 ? 'asc' : 'desc');
            }).join(',')

            console.log('ORDERED getOrderForHttp', order)
            return order
        } else {
            return ''
        }
    }
}

export function setOrder(list, order) {
    paginationStore.pagination.find((item, index) => {
        if (typeof item.list !== 'undefined') {
            if (item.list === list) {
                paginationStore.pagination[index].order = order
            }
        }
    });

    //console.log('setOrder', list, order)
}

export function getPerPage(list) {
    //console.log('getPerPage', list);
    let data = getPaginationData(list)

    if (typeof data === 'undefined') {
        //console.error('List not found:', list)
        return 10
    } else {
        return data.perPage
    }
}

export function setPerPage(list, perPage) {
    paginationStore.pagination.find((item, index) => {
        if (typeof item.list !== 'undefined') {
            if (item.list === list) {
                paginationStore.pagination[index].perPage = perPage
            }
        }
    });

    //console.log('setPerPage', list, perPage)
}